import { render, staticRenderFns } from "./BoardView.vue?vue&type=template&id=cc243274&scoped=true"
import script from "./BoardView.vue?vue&type=script&lang=js"
export * from "./BoardView.vue?vue&type=script&lang=js"
import style0 from "./BoardView.vue?vue&type=style&index=0&id=cc243274&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cc243274",
  null
  
)

export default component.exports